import React from "react";
import { TileContainer } from "./styles";

interface SelectableTileProps {
  id: string;
  label: string;
  icon: React.ReactNode;
  address: string; // Adicionada a propriedade de endereço
  selected: boolean;
  onSelect: (id: string) => void;
}

// Função para parsear o endereço
function parseFormattedAddress(address: string) {
  if (!address || typeof address !== "string") {
    return {
      logradouro: "-",
      bairro: "-",
      cidadeEstado: "-",
    };
  }

  const parts = address.split(",").map((p) => p.trim());
  // Ex: ["Av. Lago dos Patos", "Jardim Tropical", "Aparecida de Goiânia - GO", "74946-530", "Brazil"]

  const logradouro = parts[0] || "-";
  const bairro = parts[1] || "-";
  const cidadeEstado = parts[2] || "-";

  return {
    logradouro,
    bairro,
    cidadeEstado,
  };
}

const SelectableTile: React.FC<SelectableTileProps> = ({
  id,
  label,
  icon,
  address,
  selected,
  onSelect,
}) => {
  const { logradouro, bairro, cidadeEstado } = parseFormattedAddress(address);

  return (
    <TileContainer onClick={() => onSelect(id)} $selected={selected}>
      <div className="header">
        <div className="icon-wrapper">{icon}</div>
        <span className="label">{label}</span>
      </div>
      <div className="address-details">
        <span>{logradouro}</span>
        <span>{bairro}</span>
        <span>{cidadeEstado}</span>
      </div>
    </TileContainer>
  );
};

export default SelectableTile;
